"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 11.17.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequisitionItemResponseTumorProfilingReasonForTestingToJSON = exports.RequisitionItemResponseTumorProfilingReasonForTestingFromJSONTyped = exports.RequisitionItemResponseTumorProfilingReasonForTestingFromJSON = exports.instanceOfRequisitionItemResponseTumorProfilingReasonForTesting = exports.RequisitionItemResponseTumorProfilingReasonForTestingReasonForTestEnum = exports.RequisitionItemResponseTumorProfilingReasonForTestingDiseaseStatusEnum = void 0;
var runtime_1 = require("../runtime");
/**
 * @export
 */
exports.RequisitionItemResponseTumorProfilingReasonForTestingDiseaseStatusEnum = {
    LocalizedPrimary: 'disease_status_localized_primary',
    LocallyAdvanced: 'disease_status_locally_advanced',
    Metastatic: 'disease_status_metastatic',
    RecurrentLocal: 'disease_status_recurrent_local',
    RecurrentDistant: 'disease_status_recurrent_distant',
    Refractory: 'disease_status_refractory',
    Diagnostic: 'disease_status_diagnostic',
    Remission: 'disease_status_remission',
    Relapse: 'disease_status_relapse'
};
/**
 * @export
 */
exports.RequisitionItemResponseTumorProfilingReasonForTestingReasonForTestEnum = {
    BreastCancerHormoneReceptorPositive: 'breast_cancer_hormone_receptor_positive',
    BreastCancerHer2Positive: 'breast_cancer_her2_positive',
    BreastCancerTripleNegative: 'breast_cancer_triple_negative',
    BreastCancerNotProvided: 'breast_cancer_not_provided',
    ColorectalCancer: 'colorectal_cancer',
    Melanoma: 'melanoma',
    Nsclc: 'nsclc',
    ProstateCancer: 'prostate_cancer',
    OvarianCancer: 'ovarian_cancer'
};
/**
 * Check if a given object implements the RequisitionItemResponseTumorProfilingReasonForTesting interface.
 */
function instanceOfRequisitionItemResponseTumorProfilingReasonForTesting(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfRequisitionItemResponseTumorProfilingReasonForTesting = instanceOfRequisitionItemResponseTumorProfilingReasonForTesting;
function RequisitionItemResponseTumorProfilingReasonForTestingFromJSON(json) {
    return RequisitionItemResponseTumorProfilingReasonForTestingFromJSONTyped(json, false);
}
exports.RequisitionItemResponseTumorProfilingReasonForTestingFromJSON = RequisitionItemResponseTumorProfilingReasonForTestingFromJSON;
function RequisitionItemResponseTumorProfilingReasonForTestingFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'diseaseStatus': !(0, runtime_1.exists)(json, 'disease_status') ? undefined : json['disease_status'],
        'otherDiseaseStatus': !(0, runtime_1.exists)(json, 'other_disease_status') ? undefined : json['other_disease_status'],
        'stage': !(0, runtime_1.exists)(json, 'stage') ? undefined : json['stage'],
        'targetedTherapies': !(0, runtime_1.exists)(json, 'targeted_therapies') ? undefined : json['targeted_therapies'],
        'hadOrganOrBoneMarrowTransplant': !(0, runtime_1.exists)(json, 'had_organ_or_bone_marrow_transplant') ? undefined : json['had_organ_or_bone_marrow_transplant'],
        'reasonForTest': !(0, runtime_1.exists)(json, 'reason_for_test') ? undefined : json['reason_for_test'],
        'otherReasonForTest': !(0, runtime_1.exists)(json, 'other_reason_for_test') ? undefined : json['other_reason_for_test'],
        'patientHaveDiagnosisOfOtherCancers': !(0, runtime_1.exists)(json, 'patient_have_diagnosis_of_other_cancers') ? undefined : json['patient_have_diagnosis_of_other_cancers'],
        'otherCancers': !(0, runtime_1.exists)(json, 'other_cancers') ? undefined : json['other_cancers'],
        'primarySite': !(0, runtime_1.exists)(json, 'primary_site') ? undefined : json['primary_site'],
    };
}
exports.RequisitionItemResponseTumorProfilingReasonForTestingFromJSONTyped = RequisitionItemResponseTumorProfilingReasonForTestingFromJSONTyped;
function RequisitionItemResponseTumorProfilingReasonForTestingToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'disease_status': value.diseaseStatus,
        'other_disease_status': value.otherDiseaseStatus,
        'stage': value.stage,
        'targeted_therapies': value.targetedTherapies,
        'had_organ_or_bone_marrow_transplant': value.hadOrganOrBoneMarrowTransplant,
        'reason_for_test': value.reasonForTest,
        'other_reason_for_test': value.otherReasonForTest,
        'patient_have_diagnosis_of_other_cancers': value.patientHaveDiagnosisOfOtherCancers,
        'other_cancers': value.otherCancers,
        'primary_site': value.primarySite,
    };
}
exports.RequisitionItemResponseTumorProfilingReasonForTestingToJSON = RequisitionItemResponseTumorProfilingReasonForTestingToJSON;
